(() => {
  const instances = new Map();
  const sliderUtils = window.AWSliderCoreUtils;

  class AWProductFunctionality {
    constructor(root) {
      this.root = root;
      this.viewport = root.querySelector("[data-aw-product-functionality-viewport]");
      this.list = root.querySelector("[data-aw-product-functionality-list]");
      this.items = Array.from(root.querySelectorAll("[data-aw-product-functionality-item]"));
      this.scrollbar = root.querySelector("[data-aw-product-functionality-scrollbar]");
      this.prevButton = root.querySelector("[data-aw-product-functionality-prev]");
      this.nextButton = root.querySelector("[data-aw-product-functionality-next]");
      this.thumb = root.querySelector("[data-aw-product-functionality-scrollbar-thumb]");
      this.scrollFrame = null;
      this.resizeFrame = null;

      this.onPrevClick = this.onPrevClick.bind(this);
      this.onNextClick = this.onNextClick.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onImageLoad = this.onImageLoad.bind(this);

      this.bindEvents();
      this.update();
    }

    bindEvents() {
      if (this.prevButton) {
        this.prevButton.addEventListener("click", this.onPrevClick);
      }

      if (this.nextButton) {
        this.nextButton.addEventListener("click", this.onNextClick);
      }

      if (this.viewport) {
        this.viewport.addEventListener("scroll", this.onScroll, { passive: true });
      }

      window.addEventListener("resize", this.onResize);

      sliderUtils.bindImageLoad(this.root, this.onImageLoad);
    }

    destroy() {
      if (this.prevButton) {
        this.prevButton.removeEventListener("click", this.onPrevClick);
      }

      if (this.nextButton) {
        this.nextButton.removeEventListener("click", this.onNextClick);
      }

      if (this.viewport) {
        this.viewport.removeEventListener("scroll", this.onScroll);
      }

      window.removeEventListener("resize", this.onResize);

      if (this.scrollFrame) {
        window.cancelAnimationFrame(this.scrollFrame);
      }

      if (this.resizeFrame) {
        window.cancelAnimationFrame(this.resizeFrame);
      }
    }

    getItemDistance() {
      if (!this.list) return 0;

      const item = this.items[0];
      if (!item) return 0;

      return sliderUtils.getItemDistance({
        list: this.list,
        items: this.items,
        itemSelector: "[data-aw-product-functionality-item]",
        viewport: this.viewport
      });
    }

    scroll(direction) {
      if (!this.viewport) return;

      const distance = this.getItemDistance();
      if (!distance) return;

      this.viewport.scrollBy({
        left: direction * distance,
        behavior: "smooth"
      });
    }

    onPrevClick() {
      if (this.prevButton && this.prevButton.getAttribute("aria-disabled") === "true") {
        return;
      }

      this.scroll(-1);
    }

    onNextClick() {
      if (this.nextButton && this.nextButton.getAttribute("aria-disabled") === "true") {
        return;
      }

      this.scroll(1);
    }

    onScroll() {
      if (this.scrollFrame) return;

      this.scrollFrame = window.requestAnimationFrame(() => {
        this.scrollFrame = null;
        this.update();
      });
    }

    onResize() {
      if (this.resizeFrame) return;

      this.resizeFrame = window.requestAnimationFrame(() => {
        this.resizeFrame = null;
        this.update();
      });
    }

    onImageLoad() {
      this.onResize();
    }

    update() {
      if (!this.viewport) return;

      const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
      const current = this.viewport.scrollLeft;
      const hasOverflow = maxScroll > 1;

      this.root.classList.toggle("is-static", !hasOverflow);

      sliderUtils.updateButtonState(this.prevButton, !hasOverflow || current <= 1);
      sliderUtils.updateButtonState(this.nextButton, !hasOverflow || current >= maxScroll - 1);

      if (!this.thumb || !this.scrollbar) {
        return;
      }

      sliderUtils.updateScrollbar({
        viewport: this.viewport,
        scrollbar: this.scrollbar,
        thumb: this.thumb,
        enabled: hasOverflow
      });
    }
  }

  const init = (container = document) => {
    container.querySelectorAll("[data-aw-product-functionality]").forEach((root) => {
      if (instances.has(root)) return;
      instances.set(root, new AWProductFunctionality(root));
    });
  };

  const destroy = (container) => {
    container.querySelectorAll("[data-aw-product-functionality]").forEach((root) => {
      const instance = instances.get(root);
      if (!instance) return;
      instance.destroy();
      instances.delete(root);
    });
  };

  document.addEventListener("DOMContentLoaded", () => init());

  document.addEventListener("shopify:section:load", (event) => {
    init(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    destroy(event.target);
  });
})();
